<template>
    <f-dialog
        v-if    = "editcompany"
        v-model = "value"
        :title  = "$t('msd.recipient.title')"
        :width  = "800"
        :show-header = "false"

        @cancel = "onCancel"
        @store  = "onSave"
    >
        <template v-slot:content>
            <v-form ref="form">
                <v-row class="no-frame">
                    <v-col class="no-frame col-6 pr-1">
                        <c-column-header
                            class  = "primary mt-2"
                            :label = "$t(title)"
                        />

                        <div class="lm-border pa-3 mt-1">
                            <v-row class="no-frame mt-0 ">
                                <v-col class="no-frame">
                                    <v-text-field
                                        :label         = "$t('msd.company.name')"
                                        v-model        = "editcompany.name"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame mt-6">
                                <v-col class="no-frame">
                                    <v-textarea
                                        :label         = "$t('msd.company.nameAdd')"
                                        v-model="editcompany.nameAdd"
                                        no-resize
                                        rows       = "4"
                                        class      = "pt-0"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame">
                                <v-col class="no-frame">
                                    <v-text-field
                                        :label         = "$t('msd.company.street')"
                                        v-model        = "editcompany.street"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame">
                                <v-col class="no-frame col-3 pr-2">
                                    <v-text-field
                                        :label         = "$t('msd.company.zip')"
                                        v-model        = "editcompany.zip"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                                <v-col class="no-frame col-9 pl-2">
                                    <v-text-field
                                        :label         = "$t('msd.company.city')"
                                        v-model        = "editcompany.city"
                                        autocomplete   = "off"
                                        autocorrect    = "off"
                                        autocapitalize = "off"
                                        spellcheck     = "false"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame">
                                <v-col class="no-frame">
                                    <f-enum-select
                                        v-model   = "editcompany.country"
                                        label     = "Land"
                                        module    = "msd"
                                        type      = "countries"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame">
                                <v-col class="no-frame">
                                    <f-enum-select
                                        :label         = "$t('msd.company.status')"
                                        v-model      = "editcompany.status"
                                        module       = "msd"
                                        type         = "companyStatus"
                                        :hide-details = "true"
                                        class        = "mb-2"
                                    />
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                    <v-col class="no-frame col-6 pl-1">
                        <c-column-header
                            class  = "primary mt-2"
                            label = "Verwendung"
                        />

                        <div class="lm-border pa-3 mt-1" style="height: 488px">
                            <v-row class="no-frame pb-0 mb-0" >
                                <v-col class="no-frame">
                                    <v-checkbox
                                        v-model = "editcompany.liftmanagement"
                                        :label  = "$t('msd.recipient.lim')"
                                        :ripple = "false"
                                        class   = "mt-0 pa-0"
                                        hide-details
                                    />
                                    <v-checkbox
                                        v-model = "editcompany.incidentmanagement"
                                        :label  = "$t('msd.recipient.inc')"
                                        :ripple = "false"
                                        class   = "mt-0 pa-0"
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                            <v-divider class="mt-3 mb-3" />
                            <v-row class="no-frame pb-0 mb-0" >
                                <v-col class="no-frame">
                                    <v-checkbox
                                        v-model = "editcompany.benefit"
                                        :label  = "$t('msd.recipient.benefit')"
                                        :ripple = "false"
                                        class   = "mt-0 pa-0"
                                        hide-details
                                    />
                                    <v-checkbox
                                        v-model = "editcompany.invoice"
                                        :label  = "$t('msd.recipient.invoice')"
                                        :ripple = "false"
                                        class   = "mt-0 pa-0"
                                        hide-details
                                    />
                                </v-col>
                                <v-col class="no-frame pl-4 pt-1">
                                    <v-text-field
                                        v-if="editcompany.invoice && editcompany.liftmanagement"
                                        label="Debitor"
                                        v-model="editcompany.debitor"
                                    />
                                </v-col>
                            </v-row>
                            <v-divider class="mt-3 mb-3" />
                            <v-row class="no-frame " v-if="editcompany.incidentmanagement">
                                <v-col class="no-frame">
                                    <v-checkbox
                                        v-model = "editcompany.usedOnIncidents"
                                        :label  = "$t('msd.recipient.incident')"
                                        :ripple = "false"
                                        class   = "mt-0 pa-0"
                                        hide-details
                                    />
                                    <v-checkbox
                                        v-model = "editcompany.usedOnCosts"
                                        :label  = "$t('msd.recipient.costs')"
                                        :ripple = "false"
                                        class   = "mt-0 pa-0"
                                        hide-details
                                    />
                                    <v-checkbox
                                        v-model = "editcompany.usedOnRepair"
                                        :label  = "$t('msd.recipient.repair')"
                                        :ripple = "false"
                                        class   = "mt-0 pa-0"
                                        hide-details
                                    />
                                </v-col>
                            </v-row>
                        </div>
                    </v-col>
                </v-row>
            </v-form>
        </template>
    </f-dialog>
</template>

<script>

import Core        from "@/modules/core/service/Core";
import FEnumSelect from "@/modules/core/components/utils/FEnumSelect";
import FDialog     from "@/modules/core/components/utils/FDialog";
import CColumnHeader from "@/modules/core/components/utils/CColumnHeader";
import Recipients from "@/modules/msd/company/recipient/service/Recipients";

export default {
    name: "DRecipientsEdit",
    components: {
        CColumnHeader,
        FDialog,
        FEnumSelect
    },
    props: {
        value: {

        },

        recipientId: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        },

        customerId: {
            required: false,
            type    : Number,
            default : function () {
                return null;
            }
        }
    },

    data: () => ({
        editcompany:  {
            liftmanagement    : false,
            incidentmanagement: false,
            name              : null,
            debitor           : null,
            nameAdd           : null,
            street            : null,
            city              : null,
            zip               : null,
            benefit           : null,
            invoice           : null,
            usedOnIncidents   : null,
            usedOnCosts       : null,
            usedOnRepair      : null
        }
    }),

    computed: {
        title () {
            if (this.editcompany.benefit && !this.editcompany.invoice) {
                return "msd.recipient.benefit";
            }

            if (!this.editcompany.benefit && this.editcompany.invoice) {
                return "msd.recipient.invoice";
            }

            return "msd.recipient.title";
        }
    },

    watch: {
        value () {
            if (this.value) {
                this.initialize();
            }
        }
    },

    methods: {
        initialize () {
            if (!this.recipientId) {
                return;
            }

            if (this.recipientId < 0) {
                Recipients.create(this.customerId, (data) => {
                    this.editcompany = data;
                })
                return;
            }

            Recipients.findById(this.recipientId, (data) => {
                this.editcompany = data;
            })
        },

        onSave () {
            if (!this.$refs.form.validate ()) {
                return;
            }

            Recipients.store(this.editcompany, (data) => {
                this.editcompany = data;
                Core.message.alert.save(this);
                Core.fire.saved(this, this.editcompany);
            })

            this.$emit("input", false);
        },

        onCancel () {
            this.$emit("input", false);
            this.$emit("cancel");
        },
    }
}
</script>

<style scoped>
</style>